import { createApp } from 'vue';
import App from './App.vue';
import store from "./store";
import VueAxios from "vue-axios";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import "bootstrap-icons/font/bootstrap-icons.css";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import "element-plus/theme-chalk/display.css";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
import id from "element-plus/es/locale/lang/id";

axios.defaults.withCredentials = true;
axios.defaults.baseURL = process.env.VUE_APP_API || '/default-api';
axios.interceptors.request.use((config) => {
	const token = store.getters.getToken;
	if (token) config.headers.Authorization = `Bearer ${token}`;

	return config;
});

store.dispatch("loadAuth").finally(() => {
	const app = createApp(App);

	app.use(store);
	app.use(VueAxios, axios);
	app.use(ElementPlus, { locale: id });
	for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
		app.component(key, component);
	}

	app.mount("#app");
})

